import { getUsers, getAllUserRatingResults, getUserRatingResults } from '../components/Queries';
import { apiCache } from './apiCache';

// Cached version of getUsers
export const getCachedUsers = async (forceRefresh = false) => {
    const cacheKey = 'users';
    
    if (!forceRefresh) {
        const cached = apiCache.get(cacheKey);
        if (cached) {
            return cached;
        }
    }
    
    try {
        console.log('Fetching fresh users data');
        const data = await getUsers();
        apiCache.set(cacheKey, data);
        return data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

// Cached version of getAllUserRatingResults
export const getCachedAllUserRatingResults = async (forceRefresh = false) => {
    const cacheKey = 'allUserRatingResults';
    
    if (!forceRefresh) {
        const cached = apiCache.get(cacheKey);
        if (cached) {
            return cached;
        }
    }
    
    try {
        console.log('Fetching fresh user rating results');
        const data = await getAllUserRatingResults();
        apiCache.set(cacheKey, data);
        return data;
    } catch (error) {
        console.error('Error fetching user rating results:', error);
        throw error;
    }
};

// Cached version of getUserRatingResults
export const getCachedUserRatingResults = async (userId, forceRefresh = false) => {
    const cacheKey = `userRatingResults_${userId}`;
    
    if (!forceRefresh) {
        const cached = apiCache.get(cacheKey);
        if (cached) {
            return cached;
        }
    }
    
    try {
        console.log(`Fetching fresh user rating results for ${userId}`);
        const data = await getUserRatingResults(userId);
        apiCache.set(cacheKey, data);
        return data;
    } catch (error) {
        console.error(`Error fetching user rating results for ${userId}:`, error);
        throw error;
    }
};

// Function to clear cache when data is updated
export const clearUserRatingCache = (userId = null) => {
    if (userId) {
        apiCache.clear(`userRatingResults_${userId}`);
    } else {
        apiCache.clear('allUserRatingResults');
    }
};

// Function to clear all cache
export const clearAllCache = () => {
    apiCache.clearAll();
};